import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import './Footer.css';
import { END_URL, SITE_URL } from "../../config";

function Footer({ globaltest, onLoginChange, token,footerLink }) {

    const [data, setData] = useState(null);

    const [FooterData, setFooterData] = useState([]);

    const [QuickLink, setQuickLink] = useState([]);

    const tests = globaltest?.globalTest || [];

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState('');
    const [err, setErr] = useState('');


    const clearMessageAfterDelay = () => {
        setTimeout(() => {
            setMsg('');
            setErr('');
        }, 3000);
    };

    const handleBrevoSubmit = async (e) => {
        e.preventDefault();

        setMsg('');
        setErr('');

        if (!email) {
            setErr('Email is required');

             clearMessageAfterDelay();

            return;
        }

        try {
            setLoading(true);

            const res = await axios.post(`${END_URL}/brevo`, {
                email: email,
            });

            if (res.data?.success) {
                setMsg(res.data.message || 'Subscribed successfully');
                setEmail('');
                clearMessageAfterDelay();
            }
        } catch (error) {

            if (error.response?.status === 409) {
                setErr('Email already exists');
            } else {
                setErr('Something went wrong. Try again.');
            }

            clearMessageAfterDelay();

        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        const fetchFooterData = async () => {
            try {
                const res = await axios.get(`${END_URL}/home-footer`);
                
                 const payload = {
                    data: res.data.data?.[0] || null,
                    home_footer: res?.data?.home_footer || null,
                    quick_link: res?.data?.quick_link || null,
                };

                localStorage.setItem( "footer_cache_v1",JSON.stringify(payload));
                
                setData(payload.data);

                setFooterData(payload.home_footer);

                setQuickLink(payload.quick_link);
                
            } catch (error) {
                console.error("Error fetching footer data:", error);
            }
        };
        fetchFooterData();
    }, []);

    const LoginShow = () => {
        onLoginChange(true);
    };

    const knowledgeBaseLinks = useMemo(() => {
        const freeTests = tests.filter(test => test.type === "free_test");
        return [
            ...freeTests.map(test => ({
                name: test.name,
                href: `${SITE_URL}/test/${test.slug}`,
            })),
            { name: "64 Archetypes", href: "/64Archetypes" },
            { name: "ASM and NACHO", href: "/asmandnacho" },
        ];
    }, [tests]);

    const otherTests = useMemo(() => {
        const OtherTest = tests.filter(test => test.type != "free_test" && test.status ==1);
        return [
            ...OtherTest.map(test => ({
                name: test.name,
                href: `${SITE_URL}/test/${test.slug}`,
            })),
        ];
    }, [tests]);

    return (
        <div className="footer-cont">
            <footer className="footer">
                <div className="container">
                    <div className="row gy-4 footer-row">
                   
                        <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                            {data?.footerdescription && (
                                <div dangerouslySetInnerHTML={{ __html: data?.footerdescription }} />
                            )}

                            <div className="row foot-second">
                            
                                 {footerLink?.length > 0 && (

                                    footerLink.map((section) => (
                                        <div
                                            className="col-12 col-sm-6 col-md-4"
                                            key={section.id}
                                        >
                                            <div className="footer-menus">
                                                <h5>{section.heading}</h5>
                                                <ul>
                                                    {section.links?.length > 0 && (
                                                        section.links.map((link) => (
                                                            <li key={link.id}>
                                                                <a href={`/${link.url}`}>{link.label}</a>
                                                            </li>
                                                        ))
                                                    )}

                                                </ul>
                                            </div>
                                        </div>
                                    ))
                                )}

                            <div className="quick-links">

                                 <div className="footer-menus quick-links-row">
                                    
                                    <ul>
                                        <li> <a href={`/${QuickLink?.footer_link_hr_1}`}>{QuickLink?.footer_link_label_hr_1}</a> </li>
                                        
                                        <li> <a href={`/${QuickLink?.footer_link_hr_2}`}>{QuickLink?.footer_link_label_hr_2}</a> </li>

                                        <li> <a href={`/${QuickLink?.footer_link_hr_3}`}>{QuickLink?.footer_link_label_hr_3}</a> </li>
                                              
                                    </ul>
                                </div>
                            </div>

                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                            <div className="footer-box2">
                                <h3>{FooterData?.footer_question_title}</h3>

                                <form onSubmit={handleBrevoSubmit}>
                                    <div className="footer-email">
                                        <input className="footer-email-ip"  value={email} type="text"  onChange={(e) => setEmail(e.target.value)}  disabled={loading} placeholder='Enter your email' />

                                        {/* <input className="footer-submit" type="submit" value={FooterData?.footer_question_btn_label} /> */}

                                            <input
                                                className="footer-submit"
                                                type="submit"
                                                value={loading ? 'Submitting...' : FooterData?.footer_question_btn_label}
                                                disabled={loading}
                                            />

                                           {msg && (
                                                <p
                                                    style={{
                                                        color: '#2e7d32',
                                                        fontSize: '14px',
                                                        marginTop: '6px',
                                                        fontWeight: '500',
                                                    }}
                                                >
                                                    {msg}
                                                </p>
                                            )}

                                            {err && (
                                                <p
                                                    style={{
                                                        color: '#d32f2f',
                                                        fontSize: '14px',
                                                        marginTop: '6px',
                                                        fontWeight: '500',
                                                    }}
                                                >
                                                    {err}
                                                </p>
                                            )}

                                    </div>
                                </form>

                                <div className="footer-icons">
                                    <ul>
                                        {/* {data?.links && <li><a href={data?.links} target="_blank" rel="noopener noreferrer" ><i className="fab fa-facebook-f"></i></a></li>}
                                        {data?.xlink && <li><a href={data?.xlink} target="_blank" rel="noopener noreferrer" ><i className="fa-brands fa-x-twitter"></i></a></li>}
                                        {data?.instalink && <li><a href={data?.instalink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-instagram"></i></a></li>}
                                        {data?.linkedinlink && <li><a href={data?.linkedinlink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-linkedin-in"></i></a></li>} */}


                                        {data?.links && <li><a href={data?.links} target="_blank" rel="noopener noreferrer" ><i className="fab fa-facebook-f"></i></a></li>}
                                        {data?.xlink && <li><a href={data?.xlink} target="_blank" rel="noopener noreferrer" ><i className="fa-brands fa-x-twitter"></i></a></li>}
                                        {data?.instalink && <li><a href={data?.instalink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-instagram"></i></a></li>}
                                        {data?.youtub_link && <li><a href={data?.youtub_link} target="_blank" rel="noopener noreferrer" ><i class="fab fa-youtube-square"></i></a></li>}

                                        {data?.linkedinlink && <li><a href={data?.linkedinlink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-linkedin-in"></i></a></li>}

                                        {data?.tiktok_link && <li><a href={data?.tiktok_link} target="_blank" rel="noopener noreferrer" ><i class="fab fa-tiktok"></i></a></li>}
                                        {data?.pinterest_link && <li><a href={data?.pinterest_link} target="_blank" rel="noopener noreferrer" ><i class="fab fa-pinterest-p"></i></a></li>}
                                        {data?.blue_sky_link && <li><a href={data?.blue_sky_link} target="_blank" rel="noopener noreferrer" ><i className="fab fa-bluesky"></i></a></li>}
                                      

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row coppy-row">
                        <div className="col-12">
                            <div className='footer-b1-coppy'>
                                <p>© {new Date().getFullYear()}  Personality Peek. All Rights Reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
